export const ADMIN_ROUTE = '/dashboard'

export const PROJECTS_ROUTE = '/project'
export const PROJECTS_NEW_ROUTE = '/project_v2'
export const PROJECTNEW_ROUTE = '/project_new'
export const AIR_ROUTE = '/on_air'
export const COMPANYS_ROUTE = '/company'
export const PLATFORMS_ROUTE = '/location'
export const CHAT_WORKER = '/worker'
export const SPECIALIST_ROUTE = '/profile_worker'
export const CHAT_MANAGER = '/customer'
export const CLIENT_ROUTE = '/profile_customer'

export const CHAT_SUPPORT = '/support'

export const PROFILE_ROUTE = '/profile'
export const PROFILECOMPANY_ROUTE = '/my_company'
export const SETTINGS_ROUTE = '/settings'

export const DISTRIBUTION_ROUTE = '/distribution'
export const DISTRIBUTIONADD_ROUTE = '/distribution_add'
export const DISTRIBUTIONW_ROUTE = '/distributionw'
export const DISTRIBUTIONADDW_ROUTE = '/distributionw_add'
export const DISTRIBUTIONEDITW_ROUTE = '/distributionw_edit'
export const DISTRIBUTIONWPLANER_ROUTE = '/distributionw_planer'

export const THEME_ROUTE = '/theme'
export const LOGIN_ROUTE = '/login'
export const REGISTRATION_ROUTE = '/register'

export const TRASH_ROUTE = '/trash'

export const PAY_RATE_ROUTE = '/rate'

export const ESTIMATE_LIST_ROUTE = '/estimate_all'
export const ESTIMATE_ROUTE = '/estimate'
export const PARTNER_ROUTE = '/partner'
export const DOCUMENT_ROUTE = '/document'
export const DOCUMENT_COMPLECT_ROUTE = '/complect'
